import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getuserdata, encryptId, formatUrlString } from "../../../services/apiService";
import { useAuth } from "../../../context/AuthContext";
import bannerimglocal from "../../../assets/images/benner_1.jpg";
import userimglocal from "../../../assets/images/9334243.jpg";
import ImageShow from "../../../Uitiles/ImageShow";
import SidebarController from "../../../controllers/SidebarController";
import "../../../assets/styles/submenu-styles.css";

const MobileMenu = ({ isLeftPopupOpen, setIsLeftPopupOpen, isLoggedIn, userData, userimg, settings, userType }) => {
    const [userdata, setUserData] = useState({});
    const [displayName, setDisplayName] = useState("");
    const [menuList, setMenuList] = useState([]);
    const [userRole, setUserRole] = useState("");
    const [userPermissions, setUserPermissions] = useState([]);
    const { logout } = useAuth();

    const toggleSubmenu = (path, event) => {
        event.preventDefault();
        event.stopPropagation();
        
        const updatedMenuList = [...menuList];
        SidebarController.toggleSubmenu(updatedMenuList, path);
        
        setMenuList(updatedMenuList);
    };


    useEffect(() => {
        getUserProfile();
    }, []);

    useEffect(() => {
        console.log("MobileMenu userRole", userRole);
        console.log("MobileMenu userPermissions", userPermissions);
        console.log("MobileMenu displayName", displayName);
        console.log("MobileMenu userdata", userdata);
        console.log("MobileMenu userType", userType);
        if (userdata.user_type) {
            console.log("MobileMenu building menu");
            buildMenu();
        }
    }, [userType, userRole, userPermissions, displayName, userdata]);


    const getUserProfile = async () => {
        const data = await getuserdata("full");
        console.log("getUserProfile data :", data);
        setDisplayName(data?.display_name || "");
        setUserRole(data?.user_type || "");
        console.log("userRole", userRole);
        setUserPermissions(data?.permissions || []);
        setUserData(data || {});
    };

    const buildMenu = () => {
        const menu = SidebarController.buildMenu(userdata, userPermissions, displayName);
        setMenuList(menu);
    };

    const renderMenuItem = (menu, level = 0, isSubmenu = false) => {
        return menu.map((menuItem, index) => (
            <>
            <li 
                key={index} 
                className={`${SidebarController.isActivePath(window.location.pathname, menuItem.path) ? "dc-active" : ""} ${menuItem.hasChildren ? "has-submenu" : ""} ${isSubmenu ? "submenu-item" : ""
                } ${menuItem.expanded ? "submenu-expanded dc-active" : ""} ${SidebarController.isActiveSubmenu(window.location.pathname, menuItem.path) ? "submenu-expanded" : ""}`}
      
                style={
                  menuItem.hasChildren && !isSubmenu
                    ? { border: "none" }
                    : undefined
                }
                >
                {menuItem.hasChildren ? (
                    // Parent menu item with submenu
                    <a 
                        href="#" 
                        onClick={(e) => toggleSubmenu(menuItem.path, e)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <i className={menuItem.icon} style={{ marginRight: "10px" }}></i>
                            <span>{menuItem.label}</span>
                        </div>
                        {menuItem.hasChildren && (
                            <i className={`fas fa-chevron-${menuItem.expanded ? "down" : "right"}`} style={{ fontSize: "12px", transition: "transform 0.3s ease" }}></i>
                        )}
                    </a>
                ) : menuItem.type === "external" || menuItem.external ? (
                    // External link
                    <a href={menuItem.url || menuItem.path} target={menuItem.target || "_blank"} rel="noopener noreferrer" style={{ display: "flex", alignItems: "center" }}>
                        <i className={menuItem.icon} style={{ marginRight: "10px" }}></i>
                        <span>{menuItem.label}</span>
                    </a>
                ) : menuItem.type === "action" || menuItem.action ? (
                    // Action item
                    <a href="#" onClick={menuItem.action === "logout" ? logout : undefined} style={{ display: "flex", alignItems: "center" }}>
                        <i className={menuItem.icon} style={{ marginRight: "10px" }}></i>
                        <span>{menuItem.label}</span>
                    </a>
                ) : (
                    // Regular link
                    <Link to={menuItem.url || menuItem.path} onClick={menuItem.action === "logout" ? logout : handleClick } style={{ display: "flex", alignItems: "center" }}>
                        <i className={menuItem.icon} style={{ marginRight: "10px" }}></i>
                        <span>{menuItem.label}</span>
                    </Link>
                )}
                
                {/* Render submenu if expanded */}
                
            </li>
            {menuItem.hasChildren && menuItem.expanded && (
                renderMenuItem(menuItem.children, level + 1, true)
            )}
        </>
        ));
    };

    const handleClick = () => {
        console.log("handleClick");
        setIsLeftPopupOpen(false);
    }

    return (
        <div className="dc-left-popup-content">
            {userType === "doctor" || userRole === "hospital" || userRole === "pharmacy" ? (
                <>
                    <figure className="dc-companysimg">
                        {userdata.profile_banner_url ? (
                            <ImageShow
                                image={userdata.profile_banner_url}
                                height={0}
                                width={0}
                                url={userdata.profile_banner_url}
                                style={{ objectFit: "fill", objectPosition: "center" }}
                            />
                        ) : (
                            <img src={bannerimglocal} alt="banner" />
                        )}
                    </figure>
                    <div className="dc-companysinfo">
                        <figure>
                            {userdata.profile_photo_url ? (
                                <ImageShow url={userdata.profile_photo_url} width={100} height={100} />
                            ) : (
                                <img src={userimglocal} alt="profile" />
                            )}
                        </figure>
                    </div>
                    <div className="dc-title">
                        <h2 className="dc-title-h2">
                            {["admin", "hospitals", "pharmacy", "hospital-admin", "pharmacy-admin"].includes(userType) ? (
                                <a target="_blank" rel="noreferrer" href={`/doctor/${formatUrlString(displayName)}/${encryptId(userdata.id)}`}>
                                    {displayName}
                                </a>
                            ) : (
                                <a target="_blank" rel="noreferrer" href={`/doctor/${formatUrlString(displayName)}/${encryptId(userdata.id)}`}>
                                    {displayName}
                                </a>
                            )}
                        </h2>
                    </div>
                </>
            ) : (
                <div className="dc-left-popup-header">
                    <ImageShow url={settings.logo_url} key={settings.site_logo} height={0} width={150} />
                    <button
                        className="dc-left-popup-close"
                        onClick={() => setIsLeftPopupOpen(false)}
                    >
                        <i className="ti-close"></i>
                    </button>
                </div>
            )}


            {userType === "doctor" || userRole === "hospital" || userRole === "pharmacy" || userRole === "administrator" || userRole === "staff" ? (
                <>
                    <nav id="dc-navdashboard" className="dc-navdashboard">
                        <ul className="dashboard-menu-left">
                            {renderMenuItem(menuList)}
                        </ul>
                    </nav>
                </>
            ) : (
                <nav id="dc-navdashboard" className="dc-navdashboard">
                    <ul className="dashboard-menu-left">
                        <li>
                            <Link to="/search-doctors"  onClick={() => setIsLeftPopupOpen(false)}>
                                <i className="ti-user"></i>
                                <span>Find Doctors</span>
                            </Link>
                        </li>
                        
                        <li>
                        <Link to="/search-hospitals" onClick={() => setIsLeftPopupOpen(false)}>
                            <i className="ti-hospital"></i>
                            <span>Find Hospitals</span>
                        </Link>
                        </li>
                        
                        <li>
                        <Link to="/pharmacylist" onClick={() => setIsLeftPopupOpen(false)}>
                            <i className="ti-shopping-cart"></i>
                            <span>Pharmacy</span>
                        </Link>
                        </li>
                        
                        <li>

                        <Link to="/shop" onClick={() => setIsLeftPopupOpen(false)}>
                            <i className="ti-bag"></i>
                            <span>Shop</span>
                        </Link>
                        </li>
                        <li>
                        <Link to="/diagnostic" onClick={() => setIsLeftPopupOpen(false)}>
                            <i className="ti-laboratory"></i>
                            <span>Diagnostic</span>
                        </Link>
                        </li>
                    </ul>
                </nav>
            )}


            <div className="dc-left-popup-footer">
                {isLoggedIn ? (
                    <span className="dc-navdashboard-footer-text">
                        Copyrights © 2019 by OneKlicks All Rights Reserved
                    </span>
                ) : (
                    <div className="dc-left-popup-auth">
                        <Link to="/login" className="dc-left-popup-login" onClick={() => setIsLeftPopupOpen(false)}>
                            Login
                        </Link>
                        <Link to="/authentication" className="dc-left-popup-join" onClick={() => setIsLeftPopupOpen(false)}>
                            Join Now
                        </Link>
                    </div>
                )}
            </div>
        </div>
    )
}

export default MobileMenu;

